<template>
    <CRow>
        <CCol>
            <CCard>
                <CCardHeader>
                    <strong>Исключения верификации</strong>
                </CCardHeader>
                <CCardBody>
                    <CRow class="ml-1 mb-3 mr-1">
                        <p>
                            На номера телефонов, перечисленные на данной странице,
                            устанавливается фиксированный код подтверждения. При верификации
                            номера телефона код не генерируется - используется фиксированный.
                            Код подтверждения не отправляется на указанный номер телеофна.
                        </p>
                    </CRow>
                    <CButton
                        color="primary"
                        class="mb-3"
                        @click="add()"
                    >Добавить</CButton
                    >
                    <CDataTable
                        hover
                        striped
                        :items="items"
                        :fields="fields">
                        <template #actions="data">
                            <td>
                                <CButton
                                    @click="remove(data.item.phone)"
                                ><CIcon
                                    :content="$options.icons.cilTrash"
                                    class="handle"
                                /></CButton>
                            </td>
                        </template>
                    </CDataTable>
                </CCardBody>
                <CCardFooter>
                    <CButton color="primary" @click="save()">Сохранить</CButton>
                </CCardFooter>
            </CCard>
        </CCol>

        <CModal
            title="Создать исключение верификации"
            :show.sync="createModal.show"
            :footer="false"
        >
            <template>
                <div slot="body-wrapper" class="modal-body">
                    <CForm>
                        <CRow form class="form-group">
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label">
                                Номер телефона
                            </CCol>
                            <CCol sm="9">
                                <CInput v-model="createModal.phone" />
                            </CCol>
                            <CCol
                                tag="label"
                                sm="3"
                                class="col-form-label"> Код </CCol>
                            <CCol sm="9">
                                <CInput v-model="createModal.code" />
                            </CCol>
                        </CRow>
                    </CForm>
                </div>
                <div slot="footer">
                    <CButton
                        color="light"
                        class="ml-3"
                        @click="createModal.show = false"
                    >Отмена</CButton
                    >
                    <CButton
                        color="primary"
                        class="ml-3"
                        @click="createRecord"
                    >Создать</CButton
                    >
                </div>
            </template>
        </CModal>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import { cilTrash } from '@coreui/icons';

    export default {
        name: 'VerificationSettings',

        icons: {
            cilTrash,
        },

        data() {
            return {
                key: 'verification-exclude',
                items: [],
                fields: [
                    { key: 'phone', label: 'Номер телефона' },
                    { key: 'code', label: 'Код' },
                    { key: 'actions', label: 'Действия' },
                ],
                createModal: {
                    show: false,
                    phone: '',
                    code: '',
                },
            };
        },

        computed: {
        },

        watch: {},

        mounted() {
            Vue.axios
                .get('/settings/' + this.key)
                .then(resp => {
                    if(!resp.data.value.phones) {
                        resp.data.value.phones = [];
                    }
                    this.items = resp.data.value.phones;
                })
                .catch(err => {
                    this.items = []
                });
        },

        methods: {
            save() {
                Vue.axios
                    .put('/settings/' + this.key, {
                        key: this.key,
                        value: {
                            phones: this.items
                        }
                    })
                    .then(resp => {
                        this.items = resp.data.value.phones;
                    })
                    .catch(err => {
                        this.$root.$emit('showError', 'Ошибка загрузки данных.');
                    });
            },
            add() {
                this.createModal.phone = '';
                this.createModal.code = '';
                this.createModal.show = true;
            },
            createRecord() {
                if (!this.createModal.phone || !this.createModal.code) {
                    this.$root.$emit('showError', 'Введите номер телефона и код.');
                    return;
                }
                this.items = [
                    ...this.items,
                    {
                        phone: this.createModal.phone,
                        code: this.createModal.code,
                    }
                ];
                this.createModal.phone = '';
                this.createModal.code = '';
                this.createModal.show = false;
            },
            remove(phone) {
                const items = [];
                for (var i = 0; i < this.items.length; i++) {
                    if (this.items[i].phone != phone) {
                        items.push(this.items[i]);
                    }
                }
                this.items = items;
            },
        },
    };
</script>
<style scoped>
.handle {
  cursor: pointer;
  margin: 0;
  padding: 0;
}
</style>